import { Autocomplete } from "@mui/material";
import { useState } from "react";
import { ManagementCompany } from "src/pages/Admin/ManagmentCompanies/types";
import InputFinder from "src/pages/Admin/UnknownRights/UnknownRightsTable/RowSecurity/Cells/Finder/InputFinder";
import SearchNotFound from "src/pages/Admin/UnknownRights/UnknownRightsTable/RowSecurity/Cells/Finder/SearchNotFound";

import Option from "./Option";
import useGetSecuritiest from "./useGetManageCompaniesSearch";

// ----------------------------------------------------------------------

interface Props {
	value?: ManagementCompany;
	onChange: (newValue: ManagementCompany) => void;
}

export default function ManageCompanySearchInput({ onChange, value }: Props) {
	const [open, setOpen] = useState(false);

	const { data = [], onInputChange, loading, term } = useGetSecuritiest();

	function onChangeSelect(_: any, value: ManagementCompany | null) {
		if (value === null) onChange({} as ManagementCompany);
		else onChange(value);
	}

	return (
		<Autocomplete
			autoHighlight
			filterOptions={(options) => options}
			fullWidth
			getOptionLabel={({ name }: ManagementCompany) => name}
			isOptionEqualToValue={(option, value) =>
				option.managementCompanyId === value.managementCompanyId
			}
			loading={loading}
			size='small'
			noOptionsText={<SearchNotFound onClickCustomValue={() => {}} sx={{ mt: 2 }} term={term} />}
			onChange={onChangeSelect}
			onClose={() => setOpen(false)}
			onInputChange={onInputChange}
			onOpen={() => setOpen(true)}
			open={open}
			options={data}
			popupIcon={null}
			renderInput={(params) => <InputFinder {...params} />}
			renderOption={(props, option) => {
				return (
					<li
						{...props}
						key={option.managementCompanyId}
						style={{
							minWidth: "100%",
							marginTop: 0
						}}
					>
						<Option value={option} />
					</li>
				);
			}}
			value={value}
		/>
	);
}
